const url: string = "https://nhenrel43j.execute-api.eu-north-1.amazonaws.com";

export {
    url,

    
    }